export const ORDERS_STARTING_PAGE_SIZE = 25;
export const ORDERS_PAGE_SIZE_OPTIONS = [25, 50, 100];
